export const updateUserProfile = "/auth/users/profile/partner";
export const listTeams = "/auth/partner/team-member/list";
export const addTeam = "/auth/partner/team-member/add";
export const deleteTeam = (id) => `/auth/remove-team-member/partner/${id}`;
export const customizePartner = (id) => `auth/partner/${id}/customize-partner`;
export const listRoles = "/auth/roles/partner";
export const listNotificationSettings = "/core/partner/setting";
export const updateNotificationSettings = "/core/partner/update/user-setting";
export const updloadImg = "/auth/user/image/upload";
